import { useCallback, useSyncExternalStore } from "react";

// Breakpoints match antd's grid so CSS, <Col xs/md/lg> and JS all switch at the same widths.
export const BREAKPOINTS = { sm: 576, md: 768, lg: 992, xl: 1200 };

// Reads the media query synchronously on first render, so the shell doesn't flash the desktop
// layout on a phone before switching (antd's useBreakpoint starts out empty).
export const useMediaQuery = query => {
  const subscribe = useCallback(
    callback => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", callback);
      return () => mql.removeEventListener("change", callback);
    },
    [query]
  );
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false
  );
};

/** Phones and portrait tablets: navigation lives in a drawer + bottom bar. */
export const useIsCompact = () => useMediaQuery(`(max-width: ${BREAKPOINTS.lg - 0.02}px)`);

/** Phones only: full-screen dialogs, stacked forms, touch-sized controls. */
export const useIsMobile = () => useMediaQuery(`(max-width: ${BREAKPOINTS.md - 0.02}px)`);
